// material
import { Alert, Box, Container, Paper, Typography } from "@mui/material";
import CompanyForm from "../../components/authentication/login/CompanyForm";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Logo from "../../components/Logo";
import { Stack } from "@mui/system";
import LoadingScreen from "../../core/components/LoadingScreen";
import useAuth from "../../hooks/useAuth";

export default function Login() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ position: "relative", width: "100%" }}>
          {/* Logo */}
          <Box display="flex" justifyContent="center" mb={3}>
            <Logo sx={{ width: 256, height: "100%" }} />
          </Box>

          <Paper
            elevation={3}
            sx={{
              p: 4,
              width: "100%",
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {/* Başlık */}
            <Stack direction="column">
              <Typography
                variant="h4"
                align="center"
                fontWeight="bold"
              >
                Giriş Yap
              </Typography>
              <Typography
                variant="body1"
                align="center"
                color="text.secondary"
                mb={1}
              >
                Lütfen şirket kimliğinizi girin.
              </Typography>
            </Stack>

            {/* Bilgi Kutusu */}
            <Alert
              severity="info"
              icon={<InfoOutlinedIcon sx={{ color: "common.black" }} />}
              sx={{
                mb: 3,
                bgcolor: "grey.100",
                color: "common.black",
                border: "1px solid",
                borderColor: "grey.300",
                "& .MuiAlert-icon": {
                  color: "common.black",
                },
              }}
            >
              Kurumsal hesabınızla giriş yaptıktan sonra kimlik doğrulamaya
              yönlendirileceksiniz.
            </Alert>

            {/* Form */}
            <CompanyForm />
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}
